<template>
  <div>
    <b-row>
      <b-col class="col-12">
        <l-map
          ref="mapControl"
          :zoom="zoom"
          :center="center"
          :bounds="bounds"
          style="height: 800px; width: 100%"
        >
          <l-tile-layer :url="url" :attribution="attribution" />
          <l-circle
            ref="mapObjects"
            v-for="item in data"
            :key="item.id"
            :lat-lng="[item.latitude, item.longitude]"
            :color="getRoomTypeColors(item.type)"
            :fillColor="getRoomTypeColors(item.type)"
            :radius="50"
            :fillOpacity="0.5"
          >
            <!--<l-tooltip>
              <h4>{{ item.listing_title }}</h4>
              <b-row class="mt_2">
                <b-col>
                  <b>{{ $t("airdna.available_on") }}:</b>
                  <ul>
                    <li v-if="item.airbnb_property_id">Airbnb</li>
                    <li v-if="item.homeaway_property_id">Homeaway / VRBO</li>
                  </ul>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <p>
                    <b>{{ $t("airdna.occupation_days") }} :</b>
                    {{ item.occupation_days | formatNumber }}
                  </p>
                  <p>
                    <b>{{ $t("airdna.occupation_rate") }} :</b>
                    {{ item.occupation_rate | formatPercent }}
                  </p>
                </b-col>
              </b-row>
            </l-tooltip>-->
          </l-circle>
        </l-map>
      </b-col>
    </b-row>
    <b-row class="legend mt-1">
      <b-col md="3" sm="12">
        <i style="background: #3498db"></i> {{ $t("airdna.full_object") }}
      </b-col>
      <b-col md="3">
        <i style="background: #e74c3c"></i> {{ $t("airdna.private_room") }}
      </b-col>
      <b-col md="3">
        <i style="background: #f1c40f"></i> {{ $t("airdna.shared_room") }}
      </b-col>
      <b-col md="3">
        <i style="background: #7befb2"></i> {{ $t("airdna.hotel_room") }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { LMap, LTileLayer, LCircle, LTooltip } from "vue2-leaflet";
import { latLngBounds } from "leaflet";

export default {
  props: {
    data: { type: Array, required: true },
  },
  components: {
    LMap,
    LTileLayer,
    LCircle,
    LTooltip,
  },
  data() {
    return {
      center: [0, 0],
      bounds: null,
      maxBounds: null,
      zoom: 10,
      fillColor: "#e4ce7f",
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    };
  },
  methods: {
    getRoomTypeColors(room_type) {
      switch (room_type) {
        case "Logement entier":
        case "Entire home/apt":
        case "Gesamte Unterkunft":
        default:
          return "#3498db";
        case "Chambre privée":
        case "Private room":
        case "Privatzimmer":
          return "#e74c3c";
        case "Chambre partagée":
        case "Shared room":
        case "Gemeinsames Zimmer":
          return "#f1c40f";
        case "Chambre d'hôtel":
        case "Hotel room":
        case "Hotel Zimmer":
          return "#7befb2";
      }
    },
  },
  mounted() {
    this.bounds = latLngBounds(
      this.data.map((m) => {
        return [m.latitude, m.longitude];
      })
    );
    this.maxBounds = latLngBounds(
      this.data.map((m) => {
        return [m.latitude, m.longitude];
      })
    );
  },
};
</script>

<style>
.legend {
  margin-top: 10px;
  padding: 6px 8px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  box-shadow: 0 0 15px rgb(0 0 0 / 20%);
}

.legend i {
  width: 18px;
  height: 18px;
  float: left;
  margin-right: 8px;
  opacity: 0.7;
}
</style>